export const getMembershipCheckoutLink = (
    membershipId: string,
    courseSlug: string,
    isMarketplace: boolean,
    minisiteMembershipCheckoutLink: string
): string => {
    const membershipCheckoutParams: string = `membership_id=${membershipId}&course_slug=${courseSlug}&marketplace=${isMarketplace}`;
    if (isMarketplace) {
        return `/membership-checkout?${membershipCheckoutParams}`;
    }
    return `${minisiteMembershipCheckoutLink}?${membershipCheckoutParams}`;
};
